import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { MercadoSituacaoModule } from '../situacao';

import { MercadoMultiselectComponent } from './mercado-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule,
        MercadoSituacaoModule
    ],
    declarations: [
        MercadoMultiselectComponent
    ],
    exports: [
        MercadoMultiselectComponent
    ]
})
export class MercadoMultiselectModule { }
